import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { DICTS } from "@/lib/i18n";

export const Route = createFileRoute("/account/profile")({
  component: lazyRouteComponent(() => import("./-pages/account.profile")),
  head: () => ({
    meta: [
      { title: DICTS.en["account.profile.meta.title"] },
      { name: "description", content: DICTS.en["account.profile.meta.description"] },
      { property: "og:title", content: DICTS.en["account.profile.meta.title"] },
      { property: "og:description", content: DICTS.en["account.profile.meta.description"] },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});
